/**
 * BudgetTimer — ticks every 30 seconds while a ride is active and
 * emits 'budget:tick' so BudgetView can re-render the remaining time.
 * Does not mutate BudgetState itself (budget is an anchor + duration,
 * the remaining is derived on demand).
 */
export class BudgetTimer {
    constructor(_bus, _budget) {
        this._bus = _bus;
        this._budget = _budget;
        this._handle = null;
    }
    start() {
        if (this._handle !== null)
            return;
        this._emitTick();
        this._handle = window.setInterval(() => this._emitTick(), BudgetTimer.TICK_MS);
    }
    stop() {
        if (this._handle !== null) {
            window.clearInterval(this._handle);
            this._handle = null;
        }
    }
    _emitTick() {
        this._bus.emit('budget:tick', this._budget.snapshot());
    }
}
BudgetTimer.TICK_MS = 30000;
//# sourceMappingURL=BudgetTimer.js.map